// Ontario 511's road closures, incidents and roadwork, as ServiceVehicle keeps them.
// The notification carries plain entries under payload.get(RoadEventsOperations.List.PayloadKey).
export default class RoadEventsOperations {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  list() {
    var event = new RoadEventsOperations.List.Operation();
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static List = {
    Names: {
      Operation: 'RoadEventsListQueryOperation',
      Notification: 'RoadEventsListNotification',
    },

    PayloadKey: 'RoadEvents',

    Operation: function () {
      var event = {
        handler: RoadEventsOperations.List.Names.Operation,
        eventName: RoadEventsOperations.List.Names.Operation,
      }
      return event;
    },
  }
}
